<template>
  <div>
    <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :options="options" :url="url" style="overflow: hidden;">
      <div slot="created_at" slot-scope="props">
        <span class="badge badge-success p-2">{{ formatDate(props.row.created_at) }}</span>
      </div>
      <div slot="utilisateur" slot-scope="props">
        <span v-if="!getIsEmptyHelper(props.row.original_user_id)">
            {{ getUserById(props.row.gestionnaire_original) }} en tant que {{ getUserById(props.row.gestionnaire) }}</span>
        <span v-else>{{ getUserById(props.row.gestionnaire) }}</span>
      </div>
      <div slot="nom_fichier" slot-scope="props">

        <span v-if="!isEmpty(selectedDocument.chemin)" style="font-size:12px;color:#831491;cursor:pointer"><a href="#" @click="downloadFichier(props.row)"><i class="fa fa-tag"></i> {{ getFileName(props.row.nom_fichier, props.row.extension) }}</a></span>
        <router-link v-else-if="!isEmpty(selectedDocument.url)" :to="openVideo(selectedDocument)" target="_blank">
          <span>{{ selectedDocument.libelle }}</span>
        </router-link>
      </div>
    </v-server-table>
  </div>
</template>

<script>
  import { isEmpty } from "@/utils/fileHelper"
  import { formatDateTime } from "@/utils/communHelper"

  export default {
    name: 'FichiersDocument',
    props: {
      selectedDocument: {
        document: Object
      }
    },
    data() {
      let self = this;
      return {
        columns: ['created_at', 'utilisateur', 'action', 'nom_fichier'],
        url: '',
        options: {
          headings: {
            'created_at': 'Date',
            'utilisateur': 'Utilisateur',
            'action': 'Action',
            'nom_fichier': 'Fichier'
          },
          filterable: false,
          perPage: 10,
          perPageValues: [1, 10, 25],
          sortable: ['created_at'],
          requestFunction: function (data) {
            self.url = '/espaceBibliotheque/document/getFichiersDocument/' + self.selectedDocument.id;
            return axios.get(self.url, {
              params: data
            })
              .then(function(response){
                // console.log(response.data.data)
                return response;
              })
              .catch(function (e) {
                console.log(e);
              }.bind(this));
          },
        },
        isEmpty,
      }
    },
    methods: {
      onLoaded() {
        this.$store.commit("IS_LOADING", false);
      },
      getIsEmptyHelper(value) {
        return isEmpty(value)
      },
      getUserById(gestionnaire) {
        return gestionnaire ? `${gestionnaire.prenom} ${gestionnaire.nom}` : 'système';
      },
      formatDate(textDate) {
        // return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
        return formatDateTime(textDate, '/');
      },
      getFileName(nom_fichier, extension) {
        return nom_fichier +'.'+ extension
      },
      downloadFichier(document) {
        this.$eventBus.$emit('callDownloadFichier', document)
      },
      openVideo(document) {
        return {
          path: '/espace-bibliotheque/document/video/' + document.url
        }
      },
    }
  }
  </script>
